import { Link } from 'react-router-dom'

function BottomTextLink({ title, link, dot = false }) {
  return (
    <>
      <Link className="link-bottom mx-3" to={link}>
        {title}
      </Link>
      {dot ? <span className="font-[900]"> {'\u00B7'} </span> : null}
    </>
  )
}

export default BottomTextLink
